import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { defaultFiltersParams } from "#app/routes/pages/Search.page";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { DEFAULT_DIMENSION_WEIGHT } from "#shared/view/components/FilterButton";
import { FilterQuery } from "shared";

import { searchReliables, SearchReliablesDto } from "./searchReliables.api";

export const searchReliablesQuery = (
  id: string | undefined,
  filterParams: FilterQuery = defaultFiltersParams,
  dimensionWeight: number = DEFAULT_DIMENSION_WEIGHT,
) => ({
  queryKey: queryKeys.quoteRequestLines.reliables(id, filterParams, dimensionWeight),
  queryFn: () => searchReliables({ id, filterParams, dimensionWeight }),
  staleTime: STALE_TIME_L,
  enabled: !!id,
});

type SearchReliablesQueryDataUpdater =
  | SearchReliablesDto
  | undefined
  | ((old: SearchReliablesDto | undefined) => SearchReliablesDto | undefined);

export const setSearchReliablesQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: SearchReliablesQueryDataUpdater,
  filterParams: FilterQuery = defaultFiltersParams,
  dimensionWeight: number = DEFAULT_DIMENSION_WEIGHT,
): SearchReliablesDto | undefined => {
  return queryClient.setQueryData<SearchReliablesDto>(
    queryKeys.quoteRequestLines.reliables(id, filterParams, dimensionWeight),
    updater,
  );
};
